module.exports = __webpack_public_path__ + "static/media/icon-integration-active.7ea2f65d.svg";